/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        MainBot: 'MainBot',// '[장바구니 보기]를 누르면 장바구니를 볼 수 있어요.',
        List: 'List',
        Shopping: 'Shopping',
        Check: 'Check',
        Price: 'Price',
        Delivery: 'Delivery',
        NoLoginMainBot: 'NoLoginMainBot', //비로그인 파파 Bot
        Empty: 'Empty',
        Click: 'Click',
    },
    tomy:{
        kr: {
            MainBot: '장바구니 목록을 확인해보시겠어요?',
            List: '장바구니 보기',
            Shopping: '쇼핑 계속하기',
            Check: '장바구니에 담은 상품을 보여드립니다.',
            Price: '상품금액',
            Delivery: '배송비',
            Empty: '장바구니가 비어있습니다.',
            Click: '[장바구니 보기]를 누르면 장바구니를 볼 수 있어요',
        },
        eng: {
            MainBot: 'Would you like to check the shopping cart list?',
            List: 'View shopping cart',
            Shopping: 'Continue shopping',
            Check: 'Shows the items in your shopping cart.',
            Price: 'Product price',
            Delivery: 'Shipping fee',
            Empty: 'Shopping cart is empty.',
            Click: 'You can see the shopping cart if you press the button.',
        },    
    },
    papa:{
        kr: {
            NoLoginMainBot: '장바구니를 확인하려면 로그인이 필요해요.',
            MainBot: '어떤 상품을 담았는지 확인해볼까요?',
            List: '장바구니 보기',
            Shopping: '쇼핑 계속하기',
            Check: '장바구니에 담은 상품이에요.',
            Price: '상품금액',
            Delivery: '배송비',
            Empty: '장바구니가 비어 있네요. 상품을 담아 보시겠어요?',
            Click: '[장바구니 보기]를 누르면 장바구니를 볼 수 있어요',
        },
        eng: {
            NoLoginMainBot: 'You need to log in to view your shopping cart.',
            MainBot: 'Shall we check what products are included?',
            List: 'View shopping cart',
            Shopping: 'Continue shopping',
            Check: 'This is a product in your shopping cart.',
            Price: 'Product price',
            Delivery: 'Shipping fee',
            Empty: 'Shopping cart is empty. Would you ilke to put the goods?',
            Click: 'You can see the shopping cart if you press the button.',
        },
    },
};
